import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    "uuid": "",
    "name": "",
    "created_at": "",
    "accessToken": "",
    "invoices": [],
    "usageMetrics": [],
    "credits": 0,
    "autoRechargeEnabled": false,
    "autoRechargeThreshold": 0,
    "autoRechargeAmount": 0,
    "autoRechargeLimitAmount": 0
}

// Load from localStorage
const loadFromLocalStorage = () => {
    try {
        const serializedState = localStorage.getItem('papayia_account');
        if (serializedState === null) {
            return { data: initialState, storeged: false };
        }
        const parsedState = JSON.parse(serializedState);
        return {
            data: parsedState,
            storeged: true
        };
    } catch (err) {
        console.error("Error loading from localStorage:", err);
        return { data: initialState, storeged: false };
    }
};

// Save to localStorage
const saveToLocalStorage = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('papayia_account', serializedState);
    } catch (err) {
        console.error("Error saving to localStorage:", err);
    }
};

export const accountSilce = createSlice({
    name: "account",
    initialState: loadFromLocalStorage(),
    reducers: {
        updateAccount: (state, action) => {
            state.data = {
                ...state.data,
                ...action.payload
            }
            state.storeged = true
            saveToLocalStorage(state.data);
        },
        loadInvoices: (state, action) => {
            state.data.invoices = action.payload
            saveToLocalStorage(state.data);
        },
        loadUsageMetrics: (state, action) => {
            const { usageMetrics, monthTotals, yearMonth, isClosed } = action.payload || {};
            state.data.usageMetrics = usageMetrics || [];
            state.data.monthTotals = monthTotals || {};
            state.data.yearMonth = yearMonth || null;
            state.data.isClosed = !!isClosed;
            saveToLocalStorage(state.data);
        },
        clearAccount: (state) => {
            state.data = initialState;
            state.storeged = false;
            localStorage.removeItem('papayia_account');
        }
    }
})

// Action creators are generated for each case reducer function
export const { 
    loadInvoices,
    loadUsageMetrics,
    updateAccount,
    clearAccount
} = accountSilce.actions

export default accountSilce.reducer